import React from 'react';
import { AlertCircle } from 'lucide-react';
export function AlertBanner() {
  return <div className="bg-yellow-400 text-charcoal-900 py-3 px-4 text-center shadow-sm relative z-50" data-id="element-14">
      <div className="max-w-4xl mx-auto flex items-center justify-center gap-2 text-sm md:text-base font-medium" data-id="element-15">
        <AlertCircle className="w-5 h-5 flex-shrink-0" data-id="element-16" />
        <p data-id="element-17">
          <strong className="font-bold" data-id="element-18">Atención:</strong> Si eres una madre que
          lucha contra el reloj cada mañana y siente la culpa de no alimentar
          bien a sus hijos... esto es para ti.
        </p>
      </div>
    </div>;
}